import { render, staticRenderFns } from "./CheckinComments.vue?vue&type=template&id=12870773&"
import script from "./CheckinComments.vue?vue&type=script&lang=js&"
export * from "./CheckinComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports